export default "__VITE_ASSET__s7xWEYJT__"